module.exports = __webpack_public_path__ + "static/media/Icon_close.086e8452.svg";